import { render } from "./XLocationModal.vue?vue&type=template&id=a88dbe5e&scoped=true"
import script from "./XLocationModal.vue?vue&type=script&lang=js"
export * from "./XLocationModal.vue?vue&type=script&lang=js"

import "./XLocationModal.vue?vue&type=style&index=0&id=a88dbe5e&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88dbe5e"]])

export default __exports__